<script lang="tsx" setup>
import Footer from "../Footer/Footer.vue"
</script>

<template>
  <div
    class="flex min-h-screen flex-col w-full relative z-10 pointer-events-none"
  >
    <main class="flex-1 mb-gap pointer-events-auto">
      <slot />
    </main>
    <Footer class="pointer-events-auto" />
  </div>
</template>
